import {
  SUBMIT_TAX_RATE_CHANGES,
  SUBMIT_TAX_RATE_CHANGES_SUCCESS,
  SUBMIT_TAX_RATE_CHANGES_FAILED,
  FETCH_TAX_RATE_CHANGES,
  FETCH_TAX_RATE_CHANGES_SUCCESS,
  FETCH_TAX_RATE_CHANGES_FAILED,
} from './types';

const initialState = {
  loading: false,
  submitting: false,
  taxRateChanges: [],
};

const deferredRollforwardReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_TAX_RATE_CHANGES:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_TAX_RATE_CHANGES:
      return {
        ...state,
        submitting: true,
      };
    case FETCH_TAX_RATE_CHANGES_SUCCESS:
      return {
        ...state,
        loading: false,
        taxRateChanges: payload.taxRateChanges,
      };
    case FETCH_TAX_RATE_CHANGES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SUBMIT_TAX_RATE_CHANGES_SUCCESS:
      return {
        ...state,
        submitting: false,
        taxRateChanges: initialState.taxRateChanges,
      };
    case SUBMIT_TAX_RATE_CHANGES_FAILED:
      return {
        ...state,
        submitting: false,
      };
    default:
      return state;
  }
};

export default deferredRollforwardReducer;
